import type { SyntheticEvent } from 'react';

import type { SmartCardEventClickHandler } from '@atlaskit/editor-common/EventHandlers';

import { isExternalShareRequest } from '@confluence/external-share-utils/entry-points/isExternalShareRequest.ts';
import type { RoutesContextType } from '@confluence/route-manager/entry-points/RoutesContext.ts';
import { getSpaTransitionDetails } from '@confluence/route-manager/entry-points/GlobalAnchorHandler.ts';

import { isClickEventToOpenNewTab } from './isClickEventToOpenNewTab.ts';
import { isExternalLink } from './isExternalLink.ts';

export const smartCardEventHandler = (
	routesContext: Pick<RoutesContextType, 'matchRoute' | 'push'>,
	e: SyntheticEvent<HTMLAnchorElement>,
	url?: string,
): void => {
	const details = getSpaTransitionDetails(e, routesContext);

	if (isExternalLink(url)) {
		e.preventDefault();
		window.open(url, '_blank', 'noopener, noreferrer');
	} else if (details?.href && details.href === url) {
		e.preventDefault();
		routesContext.push(details.href, isExternalShareRequest());
	} else {
		handleClick(e, url);
	}
};

/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */
const handleClick: SmartCardEventClickHandler = (e, url) => {
	isClickEventToOpenNewTab(e, { shouldCheckIframe: true })
		? window.open(url, '_blank')
		: window.open(url, '_self');
};
